<template>
    <div class="shopconfig">
        <h2>Shops Config</h2>
        <div class="columns">
            <div class="col shops">
                Filter: <input class="Shopfilter" v-model="shopfilter">
                <draggable v-model="store.shopnumbers" group="nodes" :sort="false">
                    <div class="item visible" v-for="item in store.shopnumbers" :key="item.id" :class="{hidden:isHidden(item.name)}">
                       {{item.id}} - {{item.name}}
                    </div>
                </draggable>
            </div>
            <div class="col nodes">
                <div class="nodes-container">
                    <div class="node" v-for="node in nodes" :key="node.id">
                        <h4>{{node.id}}</h4>
                        <draggable class="items" v-model="node.shopnumbers" group="nodes" :sort="false">
                            <div class="item" v-for="item in node.shopnumbers" :key="item.id">
                                {{item.id}} - {{item.name}}
                            </div>
                        </draggable>
                    </div>
                </div>
                <div class="output" v-html="nodes">

                </div>

            </div>
        </div>
    </div>

</template>
<script>
    import draggable from "vuedraggable";
    import { nodes, servicePoints } from '@/nodes.js'
    export default {
        name: 'shopConfig',
        components: {
            draggable
        },
        props: ['store'],
        data(){
            return {
                shopfilter: '',
                nodes: [],
                missingShopNumbers: []
            }
        },
        computed: {
          sortedShopNumbers(){
              if (this.shopfilter === ''){
                  return this.store.shopnumbers
              } else {
                  return this.store.shopnumbers.filter(x=> x.name.indexOf(this.shopfilter) > -1 )
              }
          },
            getNodes: {
                get() {
                    return this.nodes
                },

                set(val) {
                    this.$store.commit('setExampleList', val)
                }
            }

        },
        methods: {
            // add: function() {
            //     this.list.push({ name: "Juan" });
            // },
            // replace: function() {
            //     this.list = [{ name: "Edgard" }];
            // },
            // clone: function(el) {
            //     return {
            //         name: el.name + " cloned"
            //     };
            // },
            log: function(evt) {
                window.console.log(evt);
            },
            isHidden(name){
                if (this.shopfilter.length < 1){
                    return false
                }
                else if (name.indexOf(this.shopfilter) > -1){
                    return false
                } else return true
            }
        },
        created(){
            this.nodes = nodes;
            let alShops =
            this.missingShopNumbers = store.shopnumbers;
            // this.nodes.forEach(function (el) {
            //     if (!el.shopnumbers || el.shopnumbers.length < 1){
            //         el.shopnumbers = []
            //     }
            // })
        }
    }
</script>

<style lang="scss" scoped>
    .columns {
        width: 100%;
        display: flex;
        /*flex-wrap: wrap;*/
        .col {
            /*width: 100%;*/
            /*flex-grow: 1;*/
        }
    }

    .shops {

    }

    .col.nodes {

    }

    .nodes-container {
        display: flex;
        flex-wrap: wrap;
        padding-left: 40px;
        .node {
            margin-bottom: 10px;
            width: 140px;
            margin-right: 10px;
            h4 {
                margin: 0;
            }

            .items {
                /*border: 1px solid gray;*/
                padding: 10px;
                background: #cde5e2;
                padding-bottom: 20px;
            }
        }
    }

    .item {
        /*background: #e5e5e5;*/
        border: 1px solid gray;
        background: white;
        font-size: 12px;
        padding: 5px;
        width: 120px;
        /*display: none;*/
        &.hidden {
            height: 0;
            overflow: hidden;
            padding: 0;
            border: 0;
        }
    }

    .output {
        font-size: 10px;
    }


</style>